export default function($) {
  document.querySelectorAll('.garage-item').forEach((item) => {
    var garageId = item.getAttribute('data-id');

    item.addEventListener('mouseover', () => {
      if (markers[garageId]) {
        markers[garageId].setIcon(hoverIcon);
      }
    });
    item.addEventListener('mouseout', () => {
      if (markers[garageId]) {
        markers[garageId].setIcon(defaultIcon);
      }
    });
  });
}
